export default __webpack_public_path__ + "static/media/chat.0de20a0b.png";